import * as Yup from 'yup';

export default Yup.object().shape({
    email: Yup.string().required('Заповніть це поле')
        .max(255, "Максимальна кількість символів досягнута"),
    password: Yup.string().min(5, "Мінімальна кiлькість символів 4").required('Заповніть це поле')
        .max(255, "Максимальна кількість символів досягнута")
});